import AdminSurveyPage from "./AdminSurveyPage";

export default AdminSurveyPage